import { action, makeObservable, observable } from 'mobx';
import { FilterMode } from 'src/integration/types/FilterMode';
import { PowerFilterType } from 'src/integration/types/OperationalData';

class OperationalDataStore {
  START_DATE = "2001-01-01";

  @observable powerFilter: PowerFilterType = {
    dateFrom: this.START_DATE,
    dateTo: "",
    aggregatePerInterval: FilterMode.day,
  }

  @observable enableBatteryData = true;

  @action setBatteryFilterData = (aggregatePerInterval: FilterMode, dateTo: string, dateFrom?: string) => {
    this.powerFilter = {
      dateFrom: dateFrom || this.START_DATE,
      dateTo,
      aggregatePerInterval,
    };
  };

  @action updateBatteryData = (updateData: boolean) => {
    this.enableBatteryData = updateData;
  };

  constructor() {
    makeObservable(this);
  }
}

export default OperationalDataStore;
